<template>
    <div class="user-login-view">
        <div class="login-bg"></div>
        <div style="position: fixed;bottom: 0;color: #fff">{{version}} 正式版</div>
        <!-- 登录表单 -->
        <Form ref="userLogin" :model="userLogin" :rules="ruleCustom" :label-width="80" class="ogin-view-inner absolute-center">
            <h2 class="title">登录</h2>
            <FormItem prop="supplierNo">
                <Input type="text" v-model="userLogin.supplierNo" placeholder="用户名">
                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                </Input>
            </FormItem>
            <FormItem prop="password">
                <Input type="password" v-model="userLogin.password" placeholder="密码">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                </Input>
            </FormItem>
            <p class="remember-pass">
                <Checkbox v-model="rememberPass">记住密码</Checkbox>
            </p>
            <p class="user-login-btn">
                <span @click="handleSubmit('userLogin')">登录</span>
            </p>
        </Form>

        <!-- 选择组织弹框 -->
        <Modal v-model="selectOrigin" width="360" class="select-modal" :mask-closable="false">
            <p slot="header">
                <span> 选择组织 </span>
            </p>
            <div class="select-content">
                <p class="select-title">选择要进入的组织</p>
                <Select v-model="Origin" class="select-origin" @on-change="changeOrgan">
                    <Option v-for="(item, index) in cityList" :key="index" :value="item.cliqueNo">{{ item.cliqueName }}</Option>
                </Select>
            </div>
            <div slot="footer" class="select-footer">
                <Button type="primary" size="large" long :loading="modal_loading" @click="selectOriginBtn">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { login, findInfoBySupplierNo, getAllClique, queryFunction } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
export default {
    data() {
        return {
            userLogin: {
                // 88000100
                supplierNo: '',
                password: ''
            },
            ruleCustom: {
                supplierNo: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ]
            },
            // 记住密码
            rememberPass: false,

            // 选择组织
            selectOrigin: false,
            modal_loading: false,

            // 组织选项
            cityList: [],
            Origin: '',
            projectStatus: '1',
            version: window.version
        };
    },
    methods: {
        // 登录
        async handleSubmit(name) {
            await this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$apollo.query({
                        query: login,
                        variables: this.userLogin,
                        fetchPolicy: 'network-only'
                    }).then(res => {
                        const data = res.data.login;
                        if (data && data.code === 200 && data.data) {
                            if (this.rememberPass) {
                                Cookies.set('token', data.data.accessToken, { expires: 7 });
                            } else {
                                Cookies.set('token', data.data.accessToken, { expires: 1 });
                            }
                            Cookies.set('supplierNo', this.userLogin.supplierNo, { expires: 7 });
                            this.$setNotice('登录成功');
                            window.localStorage.removeItem('activeName');
                            this.getProviderAllClique();
                            this.getInfoBySupplierNo();
                        } else {
                            this.$Notice.open({
                                title: '提示',
                                desc: data.message,
                                duration: 10
                            });
                        }
                    });
                }
            });
        },

        // 获取所有可进入的组织
        getProviderAllClique() {
            this.$apollo.query({
                query: getAllClique,
                variables: {
                    supplierNo: this.userLogin.supplierNo
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getAllClique;
                if (data && data.code === 200 && data.data) {
                    this.cityList = data.data;
                    this.selectOrigin = true;
                } else {
                    this.$setNotice('暂无组织');
                }
            });
        },
        changeOrgan(val) {
            if (val) {
                this.getfunction();
            }
        },
        // 选择组织
        selectOriginBtn() {
            if (this.cityList.findIndex(ele => ele.cliqueNo === this.Origin) !== -1) {
                if (this.rememberPass) {
                    Cookies.set('cliqueNo', this.Origin, { expires: 7 });
                } else {
                    Cookies.set('cliqueNo', this.Origin, { expires: 1 });
                }
                this.$setNotice('选取组织成功');
                this.$router.push('/index');
            } else {
                this.$setNotice('组织不能为空');
            }
        },

        // 获取当前登录供应商信息
        getInfoBySupplierNo() {
            if (Cookies.getJSON('token')) {
                this.$apollo.query({
                    query: findInfoBySupplierNo,
                    variables: {
                        supplierNo: this.userLogin.supplierNo
                    },
                    fetchPolicy: 'network-only'
                }).then(res => {
                    const data = res.data.findInfoBySupplierNo;
                    if (data && data.data && data.code === 200) {
                        Cookies.set('USER-INFO', data.data, { expires: 1 });
                    }
                });
            }
        },
        // 判断该厂是否启用模块
        getfunction() {
            this.$apollo.query({
                query: queryFunction,
                variables: {
                    cliqueNo: this.Origin
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryFunction;
                if (data && data.code === 200) {
                    const result = data.data;
                    const supplierFunction = {
                        project1: result.indexOf('project1'), // 1003计划
                        project2: result.indexOf('project2'), // 计划
                        quotation: result.indexOf('quotation'), // 1003询价单
                        productControl: result.indexOf('productControl') // 1003物资库
                    };
                    window.localStorage.setItem('supplierFunction', JSON.stringify(supplierFunction));
                }
            });
        }
    }
};
</script>

<style lang="stylus">

@import '../assets/stylus/views/user-login.styl'

</style>



// WEBPACK FOOTER //
// src/views/UserLogin.vue